import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from '@mui/material'
import { stripeDashboardUrl } from 'config/url'

const StripeLink: React.FC = () => {
  const { t } = useTranslation()
  return (
    <Link target="_blank" rel="noopener noreferrer" href={stripeDashboardUrl}>
      {t('Stripeにログイン')}
    </Link>
  )
}

export default StripeLink
